<script>
  export let quantityValue
  export let initialPricePhase
  export let expectedPriceValue

  const initialPriceColor = "#0F0"
  const expectedPriceColor = "#555555"

  const factor = 1000

  let initialPriceValues = [0.001, 0.003, 0.005]

  $: totalInitial = quantityValue * initialPriceValues[initialPricePhase]
  $: totalInitialRounded = Math.round(totalInitial * 100) / 100

  $: totalExpected = quantityValue * expectedPriceValue
  $: totalExpectedRounded = Math.round(totalExpected * 100) / 100

  $: roiMonetary = totalExpected - totalInitial
  $: roiMonetaryRounded = Math.round(roiMonetary * 100) / 100

  $: roiPercentage = (roiMonetary / totalInitial) * 100
  $: roiPercentageRounded = isNaN(roiPercentage) ? 0 : Math.round(roiPercentage * 100) / 100

  $: percentageShown = (roiMonetary / totalExpected) * 360

  $: factoredTotalInitialRounded = totalInitialRounded * factor
  $: factoredTotalExpectedRounded = totalExpectedRounded * factor
  $: factoredRoiMonetaryRounded = roiMonetaryRounded * factor

  $: factoredTotalInitialRoundedFormatted = Intl.NumberFormat().format(factoredTotalInitialRounded)
  $: factoredTotalExpectedRoundedFormatted = Intl.NumberFormat().format(factoredTotalExpectedRounded)
  $: factoredRoiMonetaryRoundedFormatted = Intl.NumberFormat().format(factoredRoiMonetaryRounded)
  $: roiPercentageRoundedFormatted = Intl.NumberFormat().format(roiPercentageRounded)
</script>

<div class="flex flex-col-reverse lg:flex-col gap-5">
  <div class="w-full flex justify-between flex-col gap-2.5 lg:flex-row">
    <div class="p-2 bg-grey border-white border-2 text-white text-sm font-medium rounded-md">Inital Investment: {factoredTotalInitialRoundedFormatted}€</div>
    <div class="p-2 bg-green/25 border-green border-2 text-green text-sm font-medium rounded-md">Expected Value: {factoredTotalExpectedRoundedFormatted}€</div>
  </div>
  <div
    class="aspect-square rounded-full flex justify-center items-center bg-[#555555]"
    style="background-image: conic-gradient({initialPriceColor} 0deg, {initialPriceColor} {percentageShown}deg, {expectedPriceColor} {percentageShown}deg);"
  >
    <div class="bg-black size-[70%] rounded-full text-center flex justify-center items-center flex-col text-copy-big font-medium gap-5 lg:gap-10">
      <span>+{factoredRoiMonetaryRoundedFormatted} €</span>
      <span>+{roiPercentageRoundedFormatted} %</span>
    </div>
  </div>
</div>
